import React, { createContext, useContext } from 'react';
import useReportsHook from '../../hooks/Dashboard/useReports';

export const ReportsContext = createContext();

export const ReportsProvider = ({ children }) => {
  const reports = useReportsHook();

  return (
    <ReportsContext.Provider value={reports}>
      {children}
    </ReportsContext.Provider>
  );
};

export const useReports = () => useContext(ReportsContext);